(() => {
  const id = new URLSearchParams(location.search).get('fanorama_checkout');
  if (!id || !/^[A-Za-z0-9_-]{22}$/.test(id)) return;
  const panel = document.getElementById('fanorama-checkout-status');
  if (!panel) return;
  const studio = 'https://studio.fanorama.art';
  const root = window.Shopify?.routes?.root || '/';
  const json = async (url, init) => {
    const response = await fetch(url, init);
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.error || panel.dataset.failed);
    return data;
  };
  const post = (path, body) => json(root + path, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(body)});
  let running = false;
  let designUrl = studio;
  async function run() {
    if (running) return;
    running = true;
    panel.hidden = false;
    panel.replaceChildren(document.createTextNode(panel.dataset.preparing));
    try {
      const data = await json(studio + '/api/checkout/' + id);
      if (!/^[0-9]+$/.test(data.variantId) || data.properties?._fanorama_checkout !== id) throw new Error(panel.dataset.failed);
      const design = new URL(data.properties._fanorama_design_url);
      if (design.origin !== studio) throw new Error(panel.dataset.failed);
      designUrl = design.href;
      const cart = await json(root + 'cart.js');
      const existing = cart.items.find(item => item.properties?._fanorama_checkout === id);
      const old = data.replace ? cart.items.find(item => item.key === data.replace.key && item.properties?._fanorama_checkout === data.replace.checkoutId) : null;
      if (data.replace && !old && !existing) throw new Error('This basket item has changed. Reopen it from your basket before editing.');
      if (old && String(old.variant_id) === data.variantId && !existing) {
        await post('cart/change.js', {id:old.key, quantity:old.quantity, properties:data.properties});
      } else {
        if (!existing) await post('cart/add.js', {items:[{id:data.variantId, quantity:old?.quantity || 1, properties:data.properties}]});
        if (old) await post('cart/change.js', {id:old.key, quantity:0});
      }
      location.replace(root + 'cart');
    } catch (error) {
      const message = document.createElement('p');
      message.textContent = error.message || panel.dataset.failed;
      const retry = document.createElement('button');
      retry.type = 'button'; retry.textContent = panel.dataset.retry;
      retry.addEventListener('click', run);
      const back = document.createElement('a');
      back.href = designUrl; back.textContent = panel.dataset.return;
      panel.replaceChildren(message, retry, back);
    } finally { running = false; }
  }
  run();
})();
